/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import HerosAndValues from "../components/HeroandValues";
import PhotoTrain from "../components/PhotoTrain";
import PortfolioShowcase from "../components/PortfolioShowcase";
import { usePhotosByGroup, usePhoto } from "../Contexts/UsePhotoManifest";
import HiItsMe from "../components/ItsMe";
import SectionFade from "../components/SectionFade";
export default function HomePage() {
    const PhotoTrainPhotos = usePhotosByGroup("phototrain");
    const PortfolioPhotos = usePhotosByGroup("portfolio");
    const WeddingPhotos = usePhotosByGroup("wedding");
    const CouplePhotos = usePhotosByGroup("couples");
    const FamilyPhotos = usePhotosByGroup("Families");
    const SeniorPhotos = usePhotosByGroup("Senior");
    const Kylie = usePhoto("KylieJeanPhotographyWhiteBackground.jpg");
    const portfolios = [
        {
            name: "Couples",
            photos: CouplePhotos,
        },
        {
            name: "Families",
            photos: FamilyPhotos,
        },
        {
            name: "Weddings",
            photos: WeddingPhotos,
        },
        {
            name: "Seniors",
            photos: SeniorPhotos,
        },
    ];
    return (React.createElement(Box, null,
        React.createElement(HerosAndValues, null),
        React.createElement(SectionFade, { threshold: 0.55 },
            React.createElement(HiItsMe, { image: Kylie?.src })),
        React.createElement(PhotoTrain, { photos: PhotoTrainPhotos }),
        React.createElement(PortfolioShowcase, { portfolios: portfolios })));
}
